import {
  jb_search_icon_css_default
} from "./chunk.NATHXL7J.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.6P2PIW72.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-search-icon/jb-search-icon.ts
var JbSearchIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="8.5"
          cy="8.5"
          r="7.87"
          stroke="currentColor"
          stroke-width="1.26"
        />
        <path
          d="M22.4346 23.4954C22.7275 23.7882 23.2023 23.7882 23.4952 23.4954C23.7881 23.2025 23.7881 22.7276 23.4952 22.4347L22.4346 23.4954ZM13.8669 14.9277L22.4346 23.4954L23.4952 22.4347L14.9275 13.867L13.8669 14.9277Z"
          fill="currentColor"
        />
      </svg>
      <slot></slot>
    `;
  }
};
JbSearchIcon.styles = jb_search_icon_css_default;
JbSearchIcon = __decorateClass([
  customElement("jb-search-icon")
], JbSearchIcon);

export {
  JbSearchIcon
};
